
























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly ctaFields: {
    message: string;
    buttons: Array<{ button: { title: string; url: string; target: string } }>;
  };

  buttonLink(link: string, target: string) {
    if (link === '#') {
      return;
    }
    const linkTarget = target || '_self';

    try {
      const url = new URL(link);

      if (
        window.location.hostname === url.hostname ||
        process.env.VUE_APP_WP_API_BASE === url.origin
      ) {
        this.$router.push(url.pathname);
      } else {
        window.open(link, linkTarget);
      }
    } catch (e) {
      window.open(link, linkTarget);
    }
  }
}
